import {Fragment} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {useGetListOfFinancingConditions} from '../hooks/useGetListOfFinancingConditions.js'

export const FinancingInfoList = ({financingData, isModal}) => {
  const listFinanceConditions = useGetListOfFinancingConditions({
    financingData,
    isModal
  })
  const getLabelClass = (isBold, isModal) =>
    cx('mt-TableFinancingDetails-financingInfoItem', {
      'mt-TableFinancingDetails-financingInfoItem--bold': isBold,
      'mt-TableFinancingDetails-financingInfoItem--modal': isModal
    })

  const hasFinancingInfo = Object.keys(financingData).length > 0

  return (
    <>
      {hasFinancingInfo &&
        listFinanceConditions.map(({id, value, labelText, isVisible, labelExtraText, isBold, highlightedValue}) => (
          <Fragment key={id}>
            {isVisible && (
              <div className={getLabelClass(isBold, isModal)}>
                <span className="mt-TableFinancingDetails-financingInfoItemLabel">
                  {labelText}
                  {Boolean(labelExtraText) && (
                    <span className="mt-TableFinancingDetails-financingInfoLabel--small">{labelExtraText}</span>
                  )}
                </span>
                <div>
                  <strong>{value}</strong>
                  {highlightedValue && <strong>**</strong>}
                </div>
              </div>
            )}
          </Fragment>
        ))}
    </>
  )
}

FinancingInfoList.displayName = 'FinancingInfoList'

FinancingInfoList.propTypes = {
  financingData: PropTypes.shape({
    availableTerm: PropTypes.bool,
    capital: PropTypes.number,
    coefficient: PropTypes.number,
    commissionEur: PropTypes.number,
    dateFirstInstallment: PropTypes.string,
    dateSignup: PropTypes.string,
    fee: PropTypes.number,
    firstFee: PropTypes.number,
    hasSpecificLegalConditions: PropTypes.bool,
    id: PropTypes.string,
    insuranceId: PropTypes.string,
    lender: PropTypes.string,
    licenseWithdrawalInsuranceAmount: PropTypes.number,
    lifeInsuranceAmount: PropTypes.number,
    maxEntry: PropTypes.number,
    minEntry: PropTypes.number,
    openingExpenses: PropTypes.number,
    openingPercentage: PropTypes.number,
    tae: PropTypes.number,
    terms: PropTypes.number,
    tin: PropTypes.number,
    totalAmountDue: PropTypes.number,
    totalInterest: PropTypes.number,
    totalLoanAmount: PropTypes.number,
    totalInsuranceAmount: PropTypes.number,
    totalLoanCost: PropTypes.number,
    totalPriceTerms: PropTypes.number,
    totalTermsAmount: PropTypes.number,
    vehiclePrice: PropTypes.number
  }).isRequired,
  isModal: PropTypes.bool
}

export default FinancingInfoList
